import { j as t } from "./jsx-runtime-721af1ab.js";
import { CloseIcon as a } from "@chakra-ui/icons";
import { VStack as p, Flex as s, Spacer as l, IconButton as c, Text as x, Box as d, Image as j } from "@chakra-ui/react";
import { h as e, aL as u } from "./eMyAsurionProvider-f4427540.js";
import "react";
import "./useAccount-5ddee56a.js";
import "./myasurion-shared.mixpanel.es.js";
import "./features-e6661c21.js";
import "./providers-a757499d.js";
import "@tanstack/react-query";
import "framer-motion";
import "./cleave-react-node-3145b543.js";
import "./lodash-3345fe65.js";
import "@react-oauth/google";
import "react-router-dom";
import "./domains-5b6d38aa.js";
import "./myasurion-shared.carrier.es.js";
import "./myasurion-shared.widgets.es.js";
import "mixpanel-browser";
import "./myasurion-shared.utils.es.js";
import "./myasurion-shared.colors.es.js";
import "@emotion/react";
import "./ProfileIcon-ce0111a3.js";
import "./myasurion-shared.profile.es.js";
import "@emotion/styled";
const R = ({
  document: i,
  setPreviewDocument: n
}) => {
  const o = i, m = () => {
    try {
      fetch(o.SignedUrl, { method: "GET" }).then((r) => r.blob()).then((r) => {
        u.saveAs(r, o.Filename);
      });
    } catch (r) {
      console.error(`Error downloading file: ${r}`);
    }
  };
  return /* @__PURE__ */ t.jsxs(p, { my: 5, children: [
    /* @__PURE__ */ t.jsxs(s, { w: "100%", children: [
      /* @__PURE__ */ t.jsx(e, { text: "View Document", translationKey: "Global/ViewDocumentLabel" }),
      /* @__PURE__ */ t.jsx(l, {}),
      /* @__PURE__ */ t.jsx(
        c,
        {
          size: "xs",
          colorScheme: "gray",
          "aria-label": "Close preview",
          icon: /* @__PURE__ */ t.jsx(a, {}),
          onClick: () => n(void 0)
        }
      )
    ] }),
    /* @__PURE__ */ t.jsxs(x, { cursor: "pointer", textDecoration: "underline", onClick: () => m(), children: [
      /* @__PURE__ */ t.jsx(e, { text: "Download file", translationKey: "Global/DownloadFile" }),
      `: ${o == null ? void 0 : o.DocumentDescription}`
    ] }),
    o.Filename.includes("pdf") && // NOTE: might need to add security headers for 'object' tags or use iframe
    /* @__PURE__ */ t.jsx(d, { as: "object", w: "100%", h: "700px", data: o == null ? void 0 : o.SignedUrl }),
    o.Filename.includes("jpg") && /* @__PURE__ */ t.jsx(j, { maxW: "100%", maxH: "700px", src: o == null ? void 0 : o.SignedUrl, alt: "document image" })
  ] });
};
export {
  R as ViewDocument
};
